import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/shared/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground focus:outline-hidden',
        secondary: 'border-transparent bg-secondary text-secondary-foreground focus:outline-hidden',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground focus:outline-hidden',
        success: 'border-transparent bg-success text-success-foreground focus:outline-hidden',
        outline: 'text-foreground border-border focus:outline-hidden',
        // Status variants for table badges (no hover effects)
        eligible: 'border-transparent bg-success text-success-foreground',
        ineligible: 'border-transparent bg-destructive text-destructive-foreground',
        verified: 'border-transparent bg-success text-success-foreground',
        unverified: 'border-transparent bg-muted text-muted-foreground',
        pending: 'border-transparent bg-secondary text-secondary-foreground',
        conflict: 'border-transparent bg-destructive text-destructive-foreground',
        current: 'border-transparent bg-success text-success-foreground',
        delinquent: 'border-transparent bg-destructive text-destructive-foreground',
        payment_plan: 'border-transparent bg-secondary text-secondary-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
